import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchWithDefaults } from "../config/fetchDefault";
import { dobFormat } from "../utilities/timeFunctions";

export const fetchLeadDataThunk = createAsyncThunk(
  "leadData/fetchLeadData",
  async ({ leadId }, { rejectWithValue }) => {
    try {
      const response = await fetchWithDefaults(`/lead/leadCard?lead=${leadId}`);
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();

      return jsonData;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const leadDataInfoSlice = createSlice({
  name: "leadAllDataInfo",
  initialState: {
    leadsAllInfoData: {},
    leadTagsList: "",
    error: null,
  },
  reducers: {
    updateSingleField(state, action) {
        const {id, field, value} = action.payload

        if(state.leadsAllInfoData.lead_id === id){
            state.leadsAllInfoData[field] = value
        }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeadDataThunk.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchLeadDataThunk.fulfilled, (state, action) => {
        state.status = "succeeded";

        if(action.payload[0].borrower_dob !== undefined){
            action.payload[0].borrower_dob = dobFormat(action.payload[0].borrower_dob)
        }

        if(action.payload[0].co_borrower_dob !== undefined){
            action.payload[0].co_borrower_dob = dobFormat(action.payload[0].co_borrower_dob)
        }

        state.leadsAllInfoData = action.payload[0];

        state.leadTagsList = action.payload[0]?.tag_ids;
      })
      .addCase(fetchLeadDataThunk.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { updateSingleField } = leadDataInfoSlice.actions;

export default leadDataInfoSlice.reducer;
